<template>
  <div style="min-height: 300px">
    <update-code
      v-if="step === 1"
      :base="base"
      type="client_multiwniosek"
      url="/client/details"
      @clientVerified="clientVerified"
    ></update-code>
    <main-form
      v-if="step === 2"
      :base="base"
      :client="client"
      :survey_type="survey_type"
      :code="code"
      :is_expert="isExpert"
      @fetchClient="fetchClient"
    ></main-form>
    <div v-if="step === 0" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
  </div>
</template>

<script>
import mainForm from "@/components/partials/forms/details/main-form";
import updateCode from "./partials/forms/update-code";
import spinner from "@/components/partials/misc/spinner";
import api from "@/services/api";
import moment from "moment";
export default {
  data() {
    return {
      loading: true,
      step: 0,
      base: null,
      code: null,
      isExpert: false,
      survey_type: 0,
      client: {
        phone_prefix: 48,
        address: {
          private: {},
          home: {},
          mailing: {},
        },
        data: {
          details: {},
          obligations: [],
          credit: {},
        },
      },
    };
  },
  components: {
    "update-code": updateCode,
    "main-form": mainForm,
    spinner,
  },
  name: "ClientDetailsForm",
  methods: {
    getExpertStorageKey() {
      return `client_multiwniosek_expert_${this.base}`;
    },
    fetchClient() {
      this.getData();
    },
    clientVerified(client, code) {
      this.client = client;
      this.code = code;
      this.step = 2;
      this.parseClient();
    },
    parseClient() {
      let self = this;
      self.survey_type = this.client.survey_type;
      if (
        self.client &&
        (!self.client.phone_prefix || self.client.phone_prefix.length < 2)
      ) {
        self.client.phone_prefix = "48";
      }
      if (self.client && (!self.client.data || self.client.data.length === 0)) {
        self.client.data = {
          details: {},
          credit: {},
        };
      } else if (
        self.client.data &&
        (!self.client.data.details || self.client.data.details.length === 0)
      ) {
        self.client.data.details = {};
      }
      if (
        typeof self.client.address.private === "undefined" ||
        !self.client.address.private
      ) {
        self.client.address.private = {};
      }
      if (
        typeof self.client.address.home === "undefined" ||
        !self.client.address.home
      ) {
        self.client.address.home = {};
      }
      if (
        typeof self.client.address.mailing === "undefined" ||
        !self.client.address.mailing
      ) {
        self.client.address.mailing = {};
      }
      if (
        typeof self.client.data.credit === "undefined" ||
        !self.client.data.credit
      ) {
        self.client.data.credit = {};
      }
      if (
        typeof self.client.data.obligations === "undefined" ||
        !self.client.data.obligations ||
        !Array.isArray(self.client.data.obligations)
      ) {
        self.client.data.obligations = [];
      }

      self.$nextTick(function () {
        self.loading = false;
        self.step = 2;
      });
    },
    getData() {
      let self = this;
      api.get(
        "/client/details/" + self.base,
        { code: this.code },
        function (data) {
          localStorage.setItem(self.base, self.code);
          localStorage.setItem(
            "client_multiwniosek",
            moment().format("YYYY-MM-DD"),
          );
          if (self.isExpert) {
            localStorage.setItem(self.getExpertStorageKey(), "1");
          }
          self.client = data;
          self.parseClient();
        },
        function () {
          localStorage.removeItem(self.base);
          localStorage.removeItem("client_multiwniosek");
          localStorage.removeItem(self.getExpertStorageKey());
          window.location.href = "https://angspoldzielnia.pl";
        },
      );
    },
  },
  mounted() {
    let self = this;
    let hasCodeInUrl = false;
    if (typeof this.$route.params.base !== "undefined") {
      this.base = this.$route.params.base;
    } else if (typeof this.$route.query.base !== "undefined") {
      this.base = this.$route.query.base;
    }

    if (!this.base) {
      window.location.href = "https://angspoldzielnia.pl";
    }

    if (typeof this.$route.params.code !== "undefined") {
      this.code = this.$route.params.code;
      hasCodeInUrl = true;
    } else if (typeof this.$route.query.code !== "undefined") {
      this.code = this.$route.query.code;
      hasCodeInUrl = true;
    }

    if (this.code) {
      if (hasCodeInUrl) {
        this.isExpert = true;
        localStorage.setItem(this.getExpertStorageKey(), "1");
      }
      self.getData();
    } else {
      let code = localStorage.getItem(this.base);
      let date = localStorage.getItem("client_multiwniosek");
      let expert = localStorage.getItem(this.getExpertStorageKey()) === "1";
      if (code && date === moment().format("YYYY-MM-DD")) {
        self.code = code;
        self.isExpert = expert;
        self.getData();
      } else {
        localStorage.removeItem(this.getExpertStorageKey());
        self.step = 1;
      }
    }
  },
};
</script>
